import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Clock, Filter } from 'lucide-react';
import { logger } from '../../utils/logger';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SupportTickets() {
  const [tickets, setTickets] = useState([]);
  const [status, setStatus] = useState('all');

  const fetchTickets = useCallback(async () => {
    try {
      const res = await fetch(`${API}/api/support/tickets?status=${status}`, { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        setTickets(data.tickets || []);
      }
    } catch (err) { logger.error("Operation failed:", err); }
  }, [status]);

  useEffect(() => { fetchTickets(); }, [fetchTickets]);


  const statusColors = {
    open: 'bg-blue-500/20 text-blue-400', in_progress: 'bg-amber-500/20 text-amber-400',
    awaiting_user: 'bg-orange-500/20 text-orange-400', resolved: 'bg-green-500/20 text-green-400',
    closed: 'bg-white/10 text-white/40', escalated: 'bg-red-500/20 text-red-400'
  };

  return (
    <div data-testid="support-tickets" className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Tickets</h1>
        <div className="flex gap-2">
          {['all', 'open', 'in_progress', 'awaiting_user', 'resolved'].map(s => (
            <button
              key={s}
              onClick={() => setStatus(s)}
              className={`px-3 py-1.5 rounded-lg text-xs transition-colors ${status === s ? 'bg-cyan-500/20 text-cyan-400' : 'bg-white/5 text-white/40 hover:text-white'}`}
            >
              {s === 'all' ? 'All' : s.replace('_', ' ')}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        {tickets.map(t => (
          <Link
            key={t.id}
            to={`/support/tickets/${t.id}`}
            className="block bg-[#0E1830] border border-white/10 rounded-xl p-4 hover:border-white/20 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <MessageSquare className="w-4 h-4 text-white/30" />
                <div>
                  <span className="text-white font-medium text-sm">{t.subject}</span>
                  <span className="text-white/30 text-xs ml-3">{t.user_email}</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                {t.is_escalated && <span className="text-xs bg-red-500/20 text-red-400 px-2 py-0.5 rounded">Escalated</span>}
                <span className={`text-xs px-2 py-0.5 rounded ${statusColors[t.status] || 'bg-white/10 text-white/40'}`}>
                  {t.status?.replace('_', ' ')}
                </span>
                <span className="text-white/30 text-xs flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  {t.created_at?.slice(0, 10)}
                </span>
              </div>
            </div>
          </Link>
        ))}
        {tickets.length === 0 && <p className="text-white/40 text-center py-12">No tickets found</p>}
      </div>
    </div>
  );
}
